"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InsertData = (function () {
    function InsertData(type, value) {
        this.type = type;
        this.value = value + '';
    }
    return InsertData;
}());
exports.InsertData = InsertData;
;



// WEBPACK FOOTER //
// ./node_modules/quill-delta-to-html/dist/commonjs/InsertData.js